export const custData = [

	// {
	// 	name: 'envestnet',
	// 	color: '#0A9BEB',
	// 	optionsTier2: [
	// 		{
	// 			name: 'cetera',
	// 			optionsTier3: [
	// 				{
	// 					title: "I'm already familiar with accessing Models on MyAdvice Architect.",
	// 					options: [
	// 						{
	// 							name: 'Take me there to access the WisdomTree Models',
	// 							url: 'https://www.cnn.com',
	// 							type: 'link',
	// 						}
	// 					]
	// 				},
	// 				{
	// 					title: "I haven't used MyAdvice Architect to access models.",
	// 					options: [
	// 						{
	// 							name: 'Download step-by-step instruction guide',
	// 							url: 'https://www.cnn.com',
	// 							type: 'download',
	// 						},
	// 						{
	// 							name: 'Email Cetera MyAdvice Architect Support Team ',
	// 							url: 'mailto:help@cetera.com',
	// 							type: 'email',
	// 						}
	// 					]
	// 				},
	// 				{
	// 					title: "I'd like to apply a tax-managed approach to WisdomTree Models.",
	// 					options: [
	// 						{
	// 							name: 'Take me to automated tax management from 55ip',
	// 							url: 'https://www.cnn.com',
	// 							type: 'link',
	// 						}
	// 					]
	// 				}
	// 			],
	// 		},
	// 		{
	// 			name: 'park avenue',
	// 		},
	// 		{
	// 			name: 'avantax',
	// 		},
	// 		{
	// 			name: "my firm isn't listed",
	// 		},
	// 	],
	// 	disclaimer: []
	// },
	{
		name: '55ip',
		color: '#050139',
		optionsTier3: [
			{
				title: "I'm already familiar with accessing Models on 55ip",
				options: [
					{
						name: 'Take me there to access the WisdomTree Models',
						url: 'https://wisdomtree.55-ip.com/accounts/register/',
						type: 'link',
					}
				]
			},
			{
				title: "I haven't used 55ip to access models.",
				options: [
					{
						name: 'I’d like to learn more about the 55ip and WisdomTree Collaboration',
						url: 'https://www.wisdomtree.com/55ip',
						type: 'link',
					},
					{
						name: 'Email 55ip Support Team.',
						url: 'mailto:info@55-ip.com',
						type: 'email',
					}
				]
			},

		],
		disclaimer: []
	},
	{
		name: 'circleblack',
		color: '#37BAC0',
		optionsTier3: [
			{
				title: "I'm already familiar with accessing Models on CircleBlack’s Model Marketplace.",
				options: [
					{
						name: 'Take me there to access the WisdomTree Models',
						url: ' https://advisor.circleblack.com/models/marketplace',
						type: 'link',
					}
				]
			},
			{
				title: "I haven't used CircleBlack’s Model Marketplace to access models.",
				options: [
					{
						name: 'Email CircleBlack Support Team',
						url: 'mailto:help@circleblack.com',
						type: 'email',
					},
				]
			},
			{
				title: "I'd like to apply a tax-managed approach to WisdomTree Models.",
				options: [
					{
						name: 'Take me to automated tax management from 55ip',
						url: 'https://www.wisdomtree.com/55ip',
						type: 'link',
					}
				]
			}
		],
		disclaimer: []
	},
	{
		name: 'morningstar model marketplace',
		color: '#F50000',
		optionsTier3: [
			{
				title: "I'm already familiar with accessing Models on the Morningstar Model Marketplace.",
				options: [
					{
						name: 'Take me there to access the WisdomTree Models',
						url: 'https://www.morningstar.com/products/office/model-marketplace',
						type: 'link',
					}
				]
			},
			{
				title: "I haven't used Morningstar Model Marketplace to access models before.",
				options: [
					{
						name: 'Email Morningstar Model Marketplace Team ',
						url: 'mailto:Blain.Hefty@morningstar.com ',
						type: 'email',
					},
				]
			},
			{
				title: "I'd like to apply a tax-managed approach to WisdomTree Models.",
				options: [
					{
						name: 'Take me to automated tax management from 55ip',
						url: 'https://www.wisdomtree.com/55ip',
						type: 'link',
					}
				]
			},
		],
		disclaimer: [{ text: 'Morningstar, Inc. is not affiliated with the Model Marketplace’s participating companies and is not responsible for the information or services provided by the companies. Use of the Model Marketplace does not constitute investment advice, an offer to buy or sell a security, or a recommendation of any company or portfolio by Morningstar and is provided for informational purposes only. Except as otherwise required by law, Morningstar shall not be responsible for any trading decisions, damages or other losses resulting from, or related to, the Model Marketplace. The Model Marketplace has no regard to the situation of any specific investor. Users must exercise their own independent judgment as to the suitability of such investments in the light of their own financial objectives and situation.  Morningstar is not affiliated with 55ip and does not sponsor, endorse, sell, promote or make any representation regarding the advisability of using 55ip.' }]
	},
	// {
	// 	name: 'interactive brokers',
	// 	color: '#B90000',
	// },
	{
		name: 'riskalyze',
		color: '#EC620A',
		optionsTier3: [
			{
				title: "I'm already familiar with accessing Models on Riskalyze’s Partner Store.",
				options: [
					{
						name: 'Take me there to access the WisdomTree Models',
						url: 'https://www.riskalyze.com/partner-store',
						type: 'link',
					}
				]
			},
			{
				title: "I haven't used Riskalyze’s Partner Store to access models.",
				options: [
					{
						name: 'Email Riskalyze Support Team',
						url: 'mailto:tjohnson@riskalyze.com',
						type: 'email',
					},
				]
			},
			{
				title: "I'd like to apply a tax-managed approach to WisdomTree Models.",
				options: [
					{
						name: 'Take me to automated tax management from 55ip',
						url: 'https://www.wisdomtree.com/55ip',
						type: 'link',
					}
				]
			},
		],
		disclaimer: [{
			text: "© 2021 Riskalyze, Inc. All Rights Reserved. Riskalyze and Risk Number are trademarks of Riskalyze, Inc. Riskalyze, Inc. is not a registered investment advisor or broker-dealer, does not make investment recommendations, nor facilitate the purchase or sale of securities. Advisors, firms, their custodians and/or broker dealers, agents or administrative assistants using Riskalyze technology certify that they hold the proper licenses and registrations to transact with and/or render advice to their clients.  Riskalyze is the company that invented the Risk Number, which powers the world's first Risk Alignment Platform and was built on top of a Nobel Prize-winning academic framework. Advisors, broker-dealers, RIAs and asset managers use the Riskalyze platform to create alignment between clients and portfolios, leverage sophisticated analytics to increase the quality of their advice, automate trading and client account management, and access world-class models and research in the Riskalyze Partner Store — all with the mission of empowering the world to invest fearlessly. To learn more, visit www.riskalyze.com."
		}]
	},
	{
		name: 'td ameritrade Institutional Model Market Center™',
		color: '#40A829',
		optionsTier3: [
			{
				title: "I’d like to learn more about the TD Ameritrade Institutional Model Market Center™",
				options: [
					{
						name: 'Take me there',
						url: 'https://www.tdainstitutional.com/offerings/investing-wealth-management/model-market-center.html',
						type: 'link',
					}
				]
			},
			{
				title: "I'd like to apply a tax-managed approach to WisdomTree Models.",
				options: [
					{
						name: 'Take me to automated tax management from 55ip',
						url: 'https://www.wisdomtree.com/55ip',
						type: 'link',
					}
				]
			},
		],
		disclaimer: [{
			text: "TD Ameritrade is separate and unaffiliated from Wisdom Tree and any of their affiliates and neither companies are responsible for the policies, opinions or services of the other. TD Ameritrade does not endorse or recommend any specific third-party managers and/or models. Model Market Center is an offering of TD Ameritrade, Inc. Registered Investment Advisor (RIA), subsidiary of The Charles Schwab Corporation. TD Ameritrade is a trademark jointly owned by TD Ameritrade IP Company, Inc. and The Toronto-Dominion Bank. Used with permission."
		}]
	},
	// {
	// 	name: 'orion portfolio solutions',
	// 	color: '#17639C',
	// },

	// {
	// 	name: "my firm isn't listed",
	// 	color: '#050139',
	// },
]